import React from 'react';
import CustomModalDialog from '../../../../components/CustomDialog';

export default function CancelOrderModal(props) {
  const { showModal, onConfirm, onCancel } = props;
  return (
    <CustomModalDialog
      showModal={showModal}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <div className="cancel-order-content">
        是否确定取消当前预约单？
      </div>
    </CustomModalDialog>
  )
}
